import { observer } from 'mobx-react-lite';
import { useKeycloakStore } from '../../shared_stores';
import { useEffect } from 'react';
import { LoadingPage } from '../loading_components';

export const LoginPage = observer(() => {
  const kcStore = useKeycloakStore();
  const queryParameters = new URLSearchParams(window.location.search);
  const redirectUri = queryParameters.get('redirectUri') || '/';

  useEffect(() => {
    void kcStore.login(redirectUri);
  }, [kcStore, redirectUri]);

  return <LoadingPage />;
});
